export const calculatePointsValue = (points, loyaltyConfig) => {
  let pointsValue = "";
  if (
    points !== null &&
    points !== "" &&
    loyaltyConfig != null &&
    loyaltyConfig !== ""
  ) {
    pointsValue = points * loyaltyConfig.contravalor;
  }
  return pointsValue;
};

export const calculatePointsFromValue = (value, loyaltyConfig) => {
  let points = "";
  if (
    value !== null &&
    value !== "" &&
    loyaltyConfig != null &&
    loyaltyConfig !== ""
  ) {
    points = value / loyaltyConfig.contravalor;
  }
  return points;
};

const calcFamilyPoints = (totalPrice, porCadaXEuros, ptosGenerados) => {
  return porCadaXEuros === 0 ? 0 : (totalPrice / porCadaXEuros) * ptosGenerados;
};

export const calculatePointsGenerated = (sale, loyaltyConfig) => {
  let pointsGenerated = 0;
  let pointsGeneratedValue = 0;
  if (loyaltyConfig.tipoAsignacion === "Importe") {
    // Puntos generados por importe

    pointsGenerated = calcFamilyPoints(
      sale.total,
      loyaltyConfig.porCadaXEurosCompra,
      loyaltyConfig.ptosGeneradosPorXEurosCompra,
    );
  } else {
    // Puntos generados por familias

    let lines = [];
    sale.lines.forEach((line) => {
      if (line.code !== "") {
        lines.push(line);
      }
    });
    sale.carts.forEach((cart) => {
      cart.lines.forEach((line) => {
        if (line.code !== "") {
          lines.push(line);
        }
      });
    });
    let totalPrice0 = 0;
    let totalPrice1 = 0;
    let totalPrice2 = 0;
    let totalPrice3 = 0;
    let totalPrice4 = 0;
    let totalPrice5 = 0;
    let totalPrice6 = 0;
    lines.forEach((line) => {
      switch (line.code[0]) {
        case "0":
          totalPrice0 += line.total;
          break;
        case "1":
          totalPrice1 += line.total;
          break;
        case "2":
          totalPrice2 += line.total;
          break;
        case "3":
          totalPrice3 += line.total;
          break;
        case "4":
          totalPrice4 += line.total;
          break;
        case "5":
          totalPrice5 += line.total;
          break;
        case "6":
          totalPrice6 += line.total;
          break;
      }
    });
    let points0 = calcFamilyPoints(
      totalPrice0,
      loyaltyConfig.porCadaXEurosAudifonos,
      loyaltyConfig.ptosGeneradosXEurosAudifonos,
    );
    let points1 = calcFamilyPoints(
      totalPrice1,
      loyaltyConfig.porCadaXEurosCristales,
      loyaltyConfig.ptosGeneradosXEurosCristales,
    );
    let points2 = calcFamilyPoints(
      totalPrice2,
      loyaltyConfig.porCadaXEurosLentillas,
      loyaltyConfig.ptosGeneradosXEurosLentillas,
    );
    let points3 = calcFamilyPoints(
      totalPrice3,
      loyaltyConfig.porCadaXEurosLiquidos,
      loyaltyConfig.ptosGeneradosXEurosLiquidos,
    );
    let points4 = calcFamilyPoints(
      totalPrice4,
      loyaltyConfig.porCadaXEurosMonturas,
      loyaltyConfig.ptosGeneradosXEurosMonturas,
    );
    let points5 = calcFamilyPoints(
      totalPrice5,
      loyaltyConfig.porCadaXEurosVarios,
      loyaltyConfig.ptosGeneradosXEurosVarios,
    );
    let points6 = calcFamilyPoints(
      totalPrice6,
      loyaltyConfig.porCadaXEurosSol,
      loyaltyConfig.ptosGeneradosXEurosSol,
    );
    pointsGenerated =
      points0 + points1 + points2 + points3 + points4 + points5 + points6;
  }
  pointsGenerated = Math.floor(pointsGenerated * 100) / 100;
  pointsGeneratedValue = pointsGenerated * loyaltyConfig.contravalor;
  return {
    pointsGenerated,
    pointsGeneratedValue,
  };
};
